import React, { useContext, useState, useMemo } from 'react'
import { useHistory } from 'react-router-dom'
import {
	SpacebetweenRowView,
	Text,
	View,
} from '../../../../../../styles/reactnative'
import { ThemeContext } from '../../../../../../theme/ThemeProvider'
import CoinRate from '../../../../../components/CoinRate/mobile'
import { COLORS, FONTS } from '../../../../../constants'
import { goTo } from '../../../../../hooks/navigation'
import { useTradeModalStore } from '../../../../../hooks/trade/modalStore'
import ThrottlePrice from './ThrottlePrice'
import { IconAlertTriangle, IconShare } from '@tabler/icons-react'
import { useLogQueue } from 'app/hooks/trade/logQueue'
import ProfitProofModal from '../../../../../components/ProfitProofCard/ProfitProofModal'
import { useExchangeStore } from 'app/hooks/trade/exchangeStore'
import { useIndexPrice } from '../../../../../hooks/trade/indexprice'
import { useCurrency } from '../../../../../hooks/trade/useCurrency'
import BigNumber from 'bignumber.js'

const OrderHeader = ({ item, coin, pnl, currency }) => {
	const { textw, textsilver } = useContext(ThemeContext).theme.COLORS
	const { data: modalStore } = useTradeModalStore()

	const { mutate: mutateLog } = useLogQueue()
	const navigation = useHistory()
	const { EPs } = useExchangeStore()
	const [profitModalVisible, setProfitModalVisible] = useState(false)
	const [selectedProfit, setSelectedProfit] = useState<any>(null)

	const EP = EPs?.find(ep => ep?.id == item?.exchange_pairs_id)

	// 평가손익 계산 (실시간)
	const { getPrice } = useIndexPrice(EP?.symbol)
	const { krwrate, getRate } = useCurrency()
	const currencyrate = getRate(EP?.currency)

	const calculatedPnl = useMemo(() => {
		if (!item?.exchange_pairs_id || item?.status == 9 || item?.status == 8 || item?.status == 10) {
			return pnl || 0
		}

		const currentPrice = getPrice(EP?.symbol)
		if (!currentPrice || currentPrice === 0) {
			return 0
		}

		const rate = BigNumber(krwrate?.price || 0)
			.div(currencyrate?.price || 0)
			.toNumber()

		const calc = new BigNumber(item?.amount)
			.multipliedBy(EP?.contractamt)
			.multipliedBy(rate)
			.toNumber()

		if (item?.long_short === 'L') {
			return BigNumber(currentPrice)
				.minus(item?.price || item?.trade_price)
				.multipliedBy(calc)
				.toNumber()
		} else {
			return BigNumber(item?.price || item?.trade_price)
				.minus(currentPrice)
				.multipliedBy(calc)
				.toNumber()
		}
	}, [item, EP, getPrice, krwrate, currencyrate, pnl])

	return (
		<>
		<SpacebetweenRowView>
			<View style={{ alignItems: 'flex-start' }}>
				<View
					style={{ flexDirection: 'row' }}
					onClick={() => {
						goTo(navigation, `/trade/${item?.exchange_pairs_id}`)
							
						mutateLog({
							log: 'FR006',
							data: {
								ep_id: item?.exchange_pairs_id
							},
						})

					}}>
					<Text style={{ ...FONTS.h6, color: textw }}>{coin}</Text>
					<CoinRate
						color={
							item?.long_short === 'L'
								? COLORS.lightRed
								: COLORS.lightGreen
						}
						content={item?.long_short === 'L' ? '매수' : '매도'}
					/>
				</View>
			</View>
			<View style={{ alignItems: 'flex-end' }}>
				<Text
					style={{
						...FONTS.h8,
						color: textsilver,
						paddingBottom: 3,
					}}>
					{modalStore?.noprice && (
						<IconAlertTriangle size={14} color={COLORS.lightRed} />
					)}
					평가손익
				</Text>
				<View style={{ flexDirection: 'row', alignItems: 'center', position: 'relative', paddingRight: 22 }}>
					<ThrottlePrice
						price={pnl}
						item={item}
						currency={currency}
						throttle={30}
					/>
					{item?.status != 1 && item?.status != 8 && item?.status != 9 && item?.status != 10 && (
						<IconShare
							size={16}
							color={calculatedPnl > 0 ? '#ff7b7b' : '#62a7ff'}
							style={{
								cursor: 'pointer',
								position: 'absolute',
								right: 0,
								top: '50%',
								transform: 'translateY(-50%)',
							}}
							onClick={e => {
								e.stopPropagation()
								setSelectedProfit({
									brandName: process.env.REACT_APP_NAME || 'EVER',
									brandUrl: window.location.origin,
									symbol: EP?.pairs || '',
									longShort: item?.long_short,
									profitAmount: calculatedPnl,
									entryPrice: item?.price,
									exitPrice: item?.trade_price,
									amount: item?.amount,
									tradedAt: new Date().toISOString(),
									isPnl: true,
								})
								setProfitModalVisible(true)
							}}
						/>
					)}
				</View>
			</View>
		</SpacebetweenRowView>

		<ProfitProofModal
			visible={profitModalVisible}
			onClose={() => setProfitModalVisible(false)}
			data={selectedProfit}
		/>
		</>
	)
}
export default React.memo(OrderHeader)
